var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVueJsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7713 0L12 5.54242L9.22873 0H0L12 24L24 0H14.7713Z",
    fill: "#41B883"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.771 0L11.9998 5.54242L9.2285 0H4.7998L11.9998 14.3997L19.1998 0H14.771Z",
    fill: "#34495E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVueJsIcon);
export default __webpack_public_path__ + "static/media/vueJS-icon.f7778207a075053eadbc446ee80b5ca5.svg";
export { ForwardRef as ReactComponent };